<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>我的订单
    </v-card-title>
    <v-card-text style="min-height:594px;">
      <!-- search form -->
      <v-row>
        <v-col cols="3">
          <v-text-field hide-details outlined dense v-model="searchFormData.tradeNo" label="订单号"></v-text-field>
        </v-col>
        <v-col cols="3">
          <date-editor hide-details outlined dense v-model="searchFormData.payDtFrom" label="支付日期(起)"></date-editor>
        </v-col>
        <v-col cols="3">
          <date-editor hide-details outlined dense v-model="searchFormData.payDtTo" label="支付日期(止)"></date-editor>
        </v-col>
        <v-col cols="3">
          <v-btn color="primary" height="40" @click="getOrderList">查 询</v-btn>
          <v-btn color="teal" height="40" dark class="ml-2" @click="onApplyOrderInvoice">申请开票</v-btn>
        </v-col>
      </v-row>

      <!-- 申请开票 -->
      <v-row v-if="applyInvoiceValid && applyInvoiceVisible" align="end">
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="3">
          <div>
            <code class="text-button">开票金额: {{applyFormData.invoiceAmount||200}}</code>
          </div>
          <v-text-field dense outlined hide-details label="发票抬头" v-model="applyFormData.ivcTitle"></v-text-field>
        </v-col>
        <v-col cols="3" class="d-flex">
          <v-btn color="primary" height="40" dark @click="applyInvoiceVisible=false">取 消</v-btn>
          <v-btn color="teal" class="ml-2" height="40" dark @click="onApplyOrderInvoiceOk">提交开票申请</v-btn>
        </v-col>

      </v-row>

      <!-- data list -->
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table dense show-select v-model="srs" item-key="id" :headers="headers" :items="dataList" hide-default-footer disable-sort disable-pagination>
            <template v-slot:item.tradeNo="{ item }">
              <v-btn x-small text color="primary" @click="onShowDetail(item)">{{item.tradeNo}}</v-btn>
            </template>
            <template v-slot:item.payDtm="{ item }">{{ Utility.fmtDt(item.payDtm, 'yyyy-mm-dd hh:mm') }}</template>
          </v-data-table>
        </v-col>
        <v-col v-if="pagination.num>pagination.index" cols="12">
          <v-btn color="primary" block text @click="getOrderListMore">
            <v-icon small>mdi-chevron-double-down</v-icon>加载更多<v-icon small>mdi-chevron-double-down</v-icon>
          </v-btn>
        </v-col>

      </v-row>
    </v-card-text>

    <!-- 订单详情 -->
    <v-dialog v-model="detailVisible" max-width="650" scrollable>
      <v-card min-height="350">
        <v-card-title>
          <div>订单详情</div>
          <v-spacer />
          <v-btn icon @click="detailVisible=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <order-detail :form-data="detailFormData" />
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-card>
</template>
<script>
/* eslint-disable no-console */
import { getOrderList, applyOrderInvoice } from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      headers: [
        { text: '订单号', value: 'tradeNo' },
        { text: '支付日期', value: 'payDtm' },
        { text: '金额', value: 'amount' },
        { text: '充值积分', value: 'pointAmount' }
      ],
      searchFormData: {},
      pagination: { index: 1, size: 10, num: 0, total: 0 },
      dataList: [],
      srs: [],
      detailVisible: false,
      detailFormData: {},
      applyInvoiceVisible: false,
      applyFormData: {}
    }
  },
  created () {
    this.getOrderList()
  },
  computed: {
    applyInvoiceValid () { // 超期以及是否申请过开票由后端校验
      return this.srs.length != 0
    },
    ...mapState({ username: state => state.username })
  },
  components: {
    OrderDetail: () => import('./OrderDetail.vue')
  },
  methods: {
    getOrderList () { // 查询
      this.srs = []
      this.pagination.index = 1
      let param = this.getQueryParam()
      getOrderList(param).then(res => {
        let d = res.data
        this.dataList = d.data || []
        this.pagination = d.pagination
      })
    },
    getOrderListMore () { // 加载更多
      let param = this.getQueryParam(this.pagination.index + 1)
      getOrderList(param).then(res => {
        let d = res.data
        this.dataList.push(...d.data)
        this.pagination = d.pagination
      })
    },
    onApplyOrderInvoice () {
      if (!this.srs.length) {
        this.$message.error('请选择需要开票的订单')
        return
      }
      this.applyFormData.ivcTitle = this.username
      let invoiceAmount = 0
      this.srs.forEach(sr => invoiceAmount += sr.amount)
      this.applyFormData.invoiceAmount = parseInt(invoiceAmount)
      this.applyInvoiceVisible = true
    },
    getQueryParam (index) { // 获取查询条件
      let param = this.Utility.clone(this.searchFormData)
      param.pagination = this.Utility.clone(this.pagination)
      if (index !== undefined) param.pagination.index = index
      if (param.payDtFrom) param.payDtFrom = this.Utility.replaceAll(param.payDtFrom, '-')
      if (param.payDtTo) param.payDtTo = this.Utility.replaceAll(param.payDtTo, '-')
      return param
    },
    onShowDetail (item) { // 显示发票详情
      this.detailFormData = this.Utility.clone(item)
      this.detailFormData.payDtm = this.Utility.fmtDt(this.detailFormData.payDtm, 'yyyy-MM-dd HH:mm')
      this.detailVisible = true
    },
    onApplyOrderInvoiceOk () { // 提交开票申请
      let orderIds = []
      this.srs.forEach(r => orderIds.push(r.id))
      let param = { orderIds: orderIds, ivcTitle: this.applyFormData.ivcTitle }
      applyOrderInvoice(param).then(() => {
        this.$message.success('申请开票成功,我们将会在在3~5个工作日处理,请留意消息通知')
        this.detailVisible = false
      })
    }
  }
}
</script>